import PropTypes from 'prop-types';
// @mui
import { styled } from '@mui/material/styles';
import { Box, Link, Typography, Tooltip } from '@mui/material';
import useAuth from '../../../hooks/useAuth';
import AvatarComponent from 'src/components/AvatarComponent';

// ----------------------------------------------------------------------

const RootStyle = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  padding: theme.spacing(2, 2.5),
  borderRadius: Number(theme.shape.borderRadius) * 1.5,
  backgroundColor: theme.palette.grey[500_12],
  transition: theme.transitions.create('opacity', {
    duration: theme.transitions.duration.shorter,
  }),
}));

// ----------------------------------------------------------------------

NavbarAccount.propTypes = {
  isCollapse: PropTypes.bool,
};

export default function NavbarAccount({ isCollapse }) {
  const { user } = useAuth();

  return (
    <Link underline="none" color="inherit">
      <RootStyle
        sx={{
          ...(isCollapse && {
            bgcolor: 'transparent',
          }),
        }}
      >
        {/* <Avatar

        >
          {user.user_nombre[0].toUpperCase()}
        </Avatar> */}
        <AvatarComponent />

        <Box
          sx={{
            ml: 2,
            transition: (theme) =>
              theme.transitions.create('width', {
                duration: theme.transitions.duration.shorter,
              }),
            ...(isCollapse && {
              ml: 0,
              width: 0,
            }),
          }}
        >
          <Tooltip title={user?.user_nombre}>
            <Typography variant="subtitle2" noWrap>
              {user?.user_nombre.length > 15
                ? user?.user_nombre.slice(0, 15) + '...'
                : user?.user_nombre}
            </Typography>
          </Tooltip>

          <Typography variant="body2" noWrap sx={{ color: 'text.secondary' }}>
            {user?.user_email?.slice(0, 15) + '...'}
          </Typography>
        </Box>
      </RootStyle>
    </Link>
  );
}
